import React, { Component } from 'react';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, set } from 'lodash';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { push as pushAction } from 'react-router-redux';

import {
  translate as t,
  FieldTitle,
  UPDATE,
  showNotification as showNotificationAction,
} from 'admin-on-rest';
import moment from 'moment';
import { RaisedButton } from 'material-ui';

import plz from 'await-plz';

import { kunal } from '../../client';
import kunalClient from '../../client/kunalClient';
import firestore from '../../config/firestore-init';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);
const headers = new Headers();
headers.append('Content-Type', 'application/json');
headers.append('X-Api-Key', process.env.REACT_APP_NODE_MAILER_API_KEY);

const style = {
  display: 'flex',
  flexFlow: 'row wrap',
  alignItems: 'center',
};

export class SelectInput extends Component {
  state = {
    value: this.props.input.value,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.input.value !== this.props.input.value) {
      this.setState({ value: nextProps.input.value });
    }
  }

  sendMail = async (record, subject, text) => {
    const [err, user] = await plz(firestore.collection('users').doc(record.submittedBy).get());
    if (err || !user.exists) return this.props.showNotification('Email sending failed because of not finding the author', 'warning');
    const userData = user.data();
    return (
      fetch(process.env.REACT_APP_NODE_MAILER_URL, {
        body: JSON.stringify({
          to: userData.email,
          from: 'catalog@pinchos.se',
          subject,
          text,
        }),
        method: 'POST',
        headers,
      })
        .then(() => (this.props.showNotification(`Email notification sent to ${userData && userData.email}`)))
        .catch(() => (this.props.showNotification(`Email notification failed to send to ${userData && userData.email}`, 'warning')))
    );
  }

  sendFeedback = () => {
    const { translate, showNotification, record, resource } = this.props;
    const feedback = prompt(translate('feedback'));

    if (feedback) {
      restClient(UPDATE, resource, {
        id: record.id,
        data: set(
          record,
          'provisionalData.discussion',
          `${record.provisionalData.discussion ? `${record.provisionalData.discussion}\n\n` : ''} ${moment().format('YYYY-MM-DD - HH:mm:ss')} - DIRECT FEEDBACK:\n${feedback}`
        ),
      })
        .then(() => {
          showNotification(`${record.id} updated`);

          if (record.submittedBy) {
            this.sendMail(
              record,
              `New feedback for ${record.internalName}`,
              `Feedback:\n${feedback}.\n ${record.provisional && record.state !== 'accepted' ? `Link to product: https://catalog.pinchos.se/#/provisional-products/${record.code}` : `Link to product: https://catalog.pinchos.se/#/products/${record.code}`}`,
            );
          } else {
            showNotification('No email notification sent because missing email address', 'warning');
          }
        })
        .catch((e) => {
          console.error(e);
          showNotification(`Error: ${record.id} not updated`, 'warning');
        });
    }
  }

  handleChange = (event, index, value) => {
    if (value === this.state.value) return null;

    const { translate, resource, source, showNotification, /* push, */ record, user } = this.props;
    const reason = prompt(translate('reason'));
    // const originalState = record.provisionalData.state;
    let data = set(record, source, value);
    if (value === 'new' || value === 'rejected') {
      data = set(record, 'provisional', true);
    }

    if (reason) {
      restClient(UPDATE, resource, {
        id: record.id,
        data: set(
          data,
          'provisionalData.discussion',
          `${data.provisionalData.discussion ? `${data.provisionalData.discussion}\n\n` : ''} STATUS CHANGED TO ${value} BY ${user.fullName} | ${moment().format('YYYY-MM-DD - HH:mm:ss')}\nMESSAGE:\n${reason}`
        ),
      })
        .then(() =>
          showNotification(`${record.id} updated`)

          // if (record.submittedBy) {
          //   this.sendMail(
          //     record,
          //     `The product ${record.internalName} status changed to ${value}`,
          //     `${record.internalName} status has been changed from ${originalState} to ${value} by ${user.fullName} at ${moment().format('YYYY-MM-DD - HH:mm:ss')}. The provided message was: \n\n${reason}.\n\n ${value !== 'accepted' ? `Link to product: https://catalog.pinchos.se/#/provisional-products/${record.code}` : ''}`
          //   );
          // } else {
          //   showNotification('No email notification sent because missing email address', 'warning');
          // }
          // if (value === 'new' || value === 'rejected') {
          //   push(`/provisional-products/${record.id}`);
          // }
          // if (value === 'accepted') {
          //   push(`/products/${record.id}`);
          // }
        )
        .catch((e) => {
          console.error(e);
          showNotification(`Error: ${record.id} not updated`, 'warning');
        });
      this.props.input.onChange(value);
      return this.setState({ value });
    }
    return null;
  };

  addAllowEmpty = (choices) => {
    if (this.props.allowEmpty) {
      return [
        <MenuItem value={null} key="null" primaryText="" />,
        ...choices,
      ];
    }

    return choices;
  };

  renderMenuItem = (choice) => {
    const {
      optionText,
      optionValue,
      translate,
      translateChoice,
    } = this.props;
    const choiceName = React.isValidElement(optionText) // eslint-disable-line no-nested-ternary
      ? React.cloneElement(optionText, { record: choice })
      : typeof optionText === 'function'
        ? optionText(choice)
        : get(choice, optionText);
    return (
      <MenuItem
        key={get(choice, optionValue)}
        primaryText={
          translateChoice ? (
            translate(choiceName, { _: choiceName })
          ) : (
            choiceName
          )
        }
        value={get(choice, optionValue)}
      />
    );
  };

  render() {
    const {
      elStyle,
      isRequired,
      label,
      meta,
      options,
      resource,
      source,
    } = this.props;
    if (typeof meta === 'undefined') {
      throw new Error(
        "The SelectInput component wasn't called within a redux-form <Field>. Did you decorate it and forget to add the addField prop to your component? See https://marmelab.com/admin-on-rest/Inputs.html#writing-your-own-input-component for details."
      );
    }
    const { touched, error } = meta;
    const choices = [
      { id: 'new', name: 'New' },
      { id: 'rejected', name: 'Rejected' },
      { id: 'accepted', name: 'Accepted' },
    ];

    return (
      <div style={style}>
        <SelectField
          value={this.state.value}
          floatingLabelText={
            <FieldTitle
              label={label}
              source={source}
              resource={resource}
              isRequired={isRequired}
            />
          }
          onChange={this.handleChange}
          autoWidth
          style={elStyle}
          errorText={touched && error}
          {...options}
        >
          {this.addAllowEmpty(choices.map(this.renderMenuItem))}
        </SelectField>
        <RaisedButton label="Direkt feedback" onClick={() => this.sendFeedback()} />
      </div>
    );
  }
}

SelectInput.propTypes = {
  addField: PropTypes.bool,
  allowEmpty: PropTypes.bool,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.object,
  options: PropTypes.object,
  optionText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.element,
  ]),
  optionValue: PropTypes.string,
  resource: PropTypes.string,
  source: PropTypes.string,
  translate: PropTypes.func.isRequired,
  translateChoice: PropTypes.bool,
};

SelectInput.defaultProps = {
  addField: true,
  allowEmpty: false,
  options: {},
  optionText: 'name',
  optionValue: 'id',
  translateChoice: true,
};

const selector = getFormValues('record-form');

export default connect(
  (state) => ({ record: selector(state) }),
  {
    showNotification: showNotificationAction,
    push: pushAction,
  }
)(t(SelectInput));
